module.exports = __webpack_public_path__ + "img/2.5.25ae5e34.png";